import transferCampainReducer from './campain';
export * from './campain';

export default { transferCampains: transferCampainReducer };
